<template>
  <div :class="loading ? 'cursor-wait' : ''">
      <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all md:w-auto sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="max-height: 80vh;">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                    <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
                        <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="claim">
                            Vista Médica ({{ claim.code }})
                        </h3>
                        <div class="flex flex-wrap pt-1 text-red-700" v-if="victimSelected != null">
                            {{ victimSelected.name }}
                        </div>
                        <div class="flex flex-wrap pt-2" v-if="victimSelected != null">
                            <div class="pb-2 mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                                <input v-model="date" type="date" :class="errors.date != null ? 'border-red-500' : ''" class="text-sm w-4/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                                <span v-if="errors.date != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                    {{ errors.date }}
                                </span>
                            </div>
                            
                            <div class="pl-4 pb-2 mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                                <input v-model="time" type="time" :class="errors.time != null ? 'border-red-500' : ''" class="text-sm w-4/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                                <span v-if="errors.time != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                    {{ errors.time }}
                                </span>
                            </div>
                        </div>

                        <div class="pl-1 pb-1 pr-1 flex flex-wrap -mx-4" v-if="victimSelected != null">
                          <div class="w-full mb-6 lg:mb-0 px-4 flex flex-col">
                            <div class="mt-2 rounded-md w-full">
                              <input type="text" v-model="place" placeholder="Lugar" class="text-sm w-full form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                              <span v-if="errors.place != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                    {{ errors.place }}
                                </span>
                            </div>
                          </div>

                          <div class="w-full mb-6 lg:mb-0 px-4 flex flex-col">
                            <div class="mt-2 rounded-md w-full">
                              <textarea rows="3" v-model="description" placeholder="Observación" class="text-sm w-full form-input py-2 appearance-none rounded-md focus:border-indigo-600"></textarea>
                              <span v-if="errors.description != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                    {{ errors.description }}
                                </span>
                            </div>
                          </div>
                        </div>

                        <div class="pl-1 pb-1 pr-1 flex flex-wrap -mx-4" v-if="victimSelected == null">
                          <div class="w-full mb-6 lg:mb-0 px-4 flex flex-col">
                            <div class="flex-grow flex flex-col bg-white border-t border-b sm:rounded sm:border shadow overflow-hidden">
                                <table class="min-w-full">
                                  <thead>
                                    <tr>
                                      <th colspan="7" class="text-xs text-white border-red-200 bg-red-400"><center>Víctimas</center></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td 
                                        class="flex items-center justify-between px-6 py-1 text-xs text-gray-700 font-medium leading-4 tracking-wider uppercase border-t border-red-200 bg-red-50">
                                        {{ claim.person.name }}
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50">
                                        {{ typesStr }}
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <div v-if="claim.medical_date_hour && claim.state.id == stateMedicalView" class="flex justify-center items-center font-medium bg-white rounded-full text-gray-700 bg-green-100 border border-green-300">
                                          {{ claim.medical_date_hour | fechaHora  }}
                                        </div>
                                      </td>
                                      <td
                                        class="border-t border-red-200 bg-red-50">
                                          <svg
                                            v-if="claim.state.id == stateMedicalView"
                                            @click="victimSelected = claim.id;updateClaim = true;cleansForm();cleansErrors()"
                                            class="w-5 h-5 mr-2 -ml-1 text-white-400 text-blue-900 cursor-pointer"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path d="M11.088,2.542c0.063-0.146,0.103-0.306,0.103-0.476c0-0.657-0.534-1.19-1.19-1.19c-0.657,0-1.19,0.533-1.19,1.19c0,0.17,0.038,0.33,0.102,0.476c-4.085,0.535-7.243,4.021-7.243,8.252c0,4.601,3.73,8.332,8.332,8.332c4.601,0,8.331-3.73,8.331-8.332C18.331,6.562,15.173,3.076,11.088,2.542z M10,1.669c0.219,0,0.396,0.177,0.396,0.396S10.219,2.462,10,2.462c-0.22,0-0.397-0.177-0.397-0.396S9.78,1.669,10,1.669z M10,18.332c-4.163,0-7.538-3.375-7.538-7.539c0-4.163,3.375-7.538,7.538-7.538c4.162,0,7.538,3.375,7.538,7.538C17.538,14.957,14.162,18.332,10,18.332z M10.386,9.26c0.002-0.018,0.011-0.034,0.011-0.053V5.24c0-0.219-0.177-0.396-0.396-0.396c-0.22,0-0.397,0.177-0.397,0.396v3.967c0,0.019,0.008,0.035,0.011,0.053c-0.689,0.173-1.201,0.792-1.201,1.534c0,0.324,0.098,0.625,0.264,0.875c-0.079,0.014-0.155,0.043-0.216,0.104l-2.244,2.244c-0.155,0.154-0.155,0.406,0,0.561s0.406,0.154,0.561,0l2.244-2.242c0.061-0.062,0.091-0.139,0.104-0.217c0.251,0.166,0.551,0.264,0.875,0.264c0.876,0,1.587-0.711,1.587-1.587C11.587,10.052,11.075,9.433,10.386,9.26z M10,11.586c-0.438,0-0.793-0.354-0.793-0.792c0-0.438,0.355-0.792,0.793-0.792c0.438,0,0.793,0.355,0.793,0.792C10.793,11.232,10.438,11.586,10,11.586z"></path>
                                          </svg>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <div v-if="claim.medical_date_hour != null && claim.state.id == stateMedicalView">Asistió <input type="checkbox" v-model="claim.medical_assist" @change="medicalAssistClaim"></div>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <svg
                                          @click="viewInfo(claim)"
                                          v-if="claim.medical_date_hour != null && claim.state.id == stateMedicalView" 
                                          class="w-5 h-5 mr-2 -ml-1 text-white-400 text-gray-20 cursor-pointer"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M18.121,9.88l-7.832-7.836c-0.155-0.158-0.428-0.155-0.584,0L1.842,9.913c-0.262,0.263-0.073,0.705,0.292,0.705h2.069v7.042c0,0.227,0.187,0.414,0.414,0.414h3.725c0.228,0,0.414-0.188,0.414-0.414v-3.313h2.483v3.313c0,0.227,0.187,0.414,0.413,0.414h3.726c0.229,0,0.414-0.188,0.414-0.414v-7.042h2.068h0.004C18.331,10.617,18.389,10.146,18.121,9.88 M14.963,17.245h-2.896v-3.313c0-0.229-0.186-0.415-0.414-0.415H8.342c-0.228,0-0.414,0.187-0.414,0.415v3.313H5.032v-6.628h9.931V17.245z M3.133,9.79l6.864-6.868l6.867,6.868H3.133z"></path>
                                        </svg>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <svg 
                                          v-if="claim.medical_victim"
                                          class="w-5 h-5 mr-2 -ml-1 text-white-400 text-green-600"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
                                        </svg>
                                      </td>
                                    </tr>
                                    <tr v-for="victim in claim.victims" :key="victim.id">
                                      <td 
                                        class="flex items-center justify-between px-6 py-1 text-xs text-gray-700 font-medium leading-4 tracking-wider uppercase border-t border-red-200 bg-red-50">
                                        {{ victim.person.name }}
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50">
                                        <span v-if="victim.type" class="text-xs font-xs leading-none max-w-full flex-initial">{{ victim.type.name }}</span>
                                        <span v-if="victim.type2" class="text-xs font-xs leading-none max-w-full flex-initial"> - {{ victim.type2.name }}</span>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <div v-if="victim.medical_date_hour != null && claim.state.id == stateMedicalView" class="flex justify-center items-center font-medium bg-white rounded-full text-gray-700 bg-green-100 border border-green-300">
                                          {{ victim.medical_date_hour | fechaHora  }}
                                        </div>
                                      </td>
                                      <td
                                        class="border-t border-red-200 bg-red-50">
                                          <svg
                                            v-if="claim.state.id == stateMedicalView"
                                            @click="victimSelected = victim.id;updateClaim = false;cleansForm();cleansErrors()"
                                            class="w-5 h-5 mr-2 -ml-1 text-white-400 text-blue-900 cursor-pointer"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path d="M11.088,2.542c0.063-0.146,0.103-0.306,0.103-0.476c0-0.657-0.534-1.19-1.19-1.19c-0.657,0-1.19,0.533-1.19,1.19c0,0.17,0.038,0.33,0.102,0.476c-4.085,0.535-7.243,4.021-7.243,8.252c0,4.601,3.73,8.332,8.332,8.332c4.601,0,8.331-3.73,8.331-8.332C18.331,6.562,15.173,3.076,11.088,2.542z M10,1.669c0.219,0,0.396,0.177,0.396,0.396S10.219,2.462,10,2.462c-0.22,0-0.397-0.177-0.397-0.396S9.78,1.669,10,1.669z M10,18.332c-4.163,0-7.538-3.375-7.538-7.539c0-4.163,3.375-7.538,7.538-7.538c4.162,0,7.538,3.375,7.538,7.538C17.538,14.957,14.162,18.332,10,18.332z M10.386,9.26c0.002-0.018,0.011-0.034,0.011-0.053V5.24c0-0.219-0.177-0.396-0.396-0.396c-0.22,0-0.397,0.177-0.397,0.396v3.967c0,0.019,0.008,0.035,0.011,0.053c-0.689,0.173-1.201,0.792-1.201,1.534c0,0.324,0.098,0.625,0.264,0.875c-0.079,0.014-0.155,0.043-0.216,0.104l-2.244,2.244c-0.155,0.154-0.155,0.406,0,0.561s0.406,0.154,0.561,0l2.244-2.242c0.061-0.062,0.091-0.139,0.104-0.217c0.251,0.166,0.551,0.264,0.875,0.264c0.876,0,1.587-0.711,1.587-1.587C11.587,10.052,11.075,9.433,10.386,9.26z M10,11.586c-0.438,0-0.793-0.354-0.793-0.792c0-0.438,0.355-0.792,0.793-0.792c0.438,0,0.793,0.355,0.793,0.792C10.793,11.232,10.438,11.586,10,11.586z"></path>
                                          </svg>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <div v-if="victim.medical_date_hour != null && claim.state.id == stateMedicalView">Asistió <input type="checkbox" v-model="victim.medical_assist" @change="medicalAssistVictim(victim)"></div>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <svg 
                                          @click="viewInfo(victim)"
                                          v-if="victim.medical_date_hour != null && claim.state.id == stateMedicalView"
                                          class="w-5 h-5 mr-2 -ml-1 text-white-400 text-gray-20 cursor-pointer"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M18.121,9.88l-7.832-7.836c-0.155-0.158-0.428-0.155-0.584,0L1.842,9.913c-0.262,0.263-0.073,0.705,0.292,0.705h2.069v7.042c0,0.227,0.187,0.414,0.414,0.414h3.725c0.228,0,0.414-0.188,0.414-0.414v-3.313h2.483v3.313c0,0.227,0.187,0.414,0.413,0.414h3.726c0.229,0,0.414-0.188,0.414-0.414v-7.042h2.068h0.004C18.331,10.617,18.389,10.146,18.121,9.88 M14.963,17.245h-2.896v-3.313c0-0.229-0.186-0.415-0.414-0.415H8.342c-0.228,0-0.414,0.187-0.414,0.415v3.313H5.032v-6.628h9.931V17.245z M3.133,9.79l6.864-6.868l6.867,6.868H3.133z"></path>
                                        </svg>
                                      </td>
                                      <td
                                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50 pr-4">
                                        <svg 
                                          v-if="victim.medical"
                                          class="w-5 h-5 mr-2 -ml-1 text-white-400 text-green-600"
                                          fill="currentColor"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
                                        </svg>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button 
                        v-if="victimSelected != null"
                        @click="victimSelected = null"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >  
                            <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                            </path>
                        </svg>
                        Cancelar
                    </button>
                </span>
                
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button 
                        v-if="victimSelected != null"
                        @click="schedule"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                            </path>
                        </svg>
                        Aceptar
                    </button>
                </span>

                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button 
                        v-if="victimSelected == null"
                        @click="closeModal"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path d="M3.24,7.51c-0.146,0.142-0.146,0.381,0,0.523l5.199,5.193c0.234,0.238,0.633,0.064,0.633-0.262v-2.634c0.105-0.007,0.212-0.011,0.321-0.011c2.373,0,4.302,1.91,4.302,4.258c0,0.957-0.33,1.809-1.008,2.602c-0.259,0.307,0.084,0.762,0.451,0.572c2.336-1.195,3.73-3.408,3.73-5.924c0-3.741-3.103-6.783-6.916-6.783c-0.307,0-0.615,0.028-0.881,0.063V2.575c0-0.327-0.398-0.5-0.633-0.261L3.24,7.51 M4.027,7.771l4.301-4.3v2.073c0,0.232,0.21,0.409,0.441,0.366c0.298-0.056,0.746-0.123,1.184-0.123c3.402,0,6.172,2.709,6.172,6.041c0,1.695-0.718,3.24-1.979,4.352c0.193-0.51,0.293-1.045,0.293-1.602c0-2.76-2.266-5-5.046-5c-0.256,0-0.528,0.018-0.747,0.05C8.465,9.653,8.328,9.81,8.328,9.995v2.074L4.027,7.771z">
                            </path>
                        </svg>
                        Volver
                    </button>
                </span>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify'
import { ConstantMap } from '@/constant.js'

Vue.use(VueAlertify)

export default {
  props: {
      claim: {},
      modal: false,
  },

  data() {
    return {
      loading: false,
      date: null,
      time: null,
      place: null,
      description: null,
      errors: {
        date: null,
        time: null,
        place: null,
        description: null,
      },
      isInjuries: null,
      typesStr: "",
      victimSelected: null,
      updateClaim: null,
      stateMedicalView: ConstantMap.STATE_MEDICAL_VIEW
    }
  },

  watch: {
    modal (value) {
      if (value) {
        this.typesStr = ""
        this.victimSelected = null
        this.checkInjuries()
      }
    }
  },

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    checkInjuries() {
      this.isInjuries = (this.claim.types.filter(t => t.id == ConstantMap.CLAIM_TYPE_INJURIES).length > 0)
      //const types = this.claim.types.filter(t => t.id != ConstantMap.CLAIM_TYPE_MATERIAL_DAMAGE)
      //types.forEach(type => {
      this.claim.types.forEach(type => {
        if (this.typesStr === ""){
          this.typesStr = type.name
        } else {
          this.typesStr += " - "+type.name
        }
      })
    },
    cleansForm() {
      this.date = null
      this.time = null
      this.place = null
      this.description = null
    },
    cleansErrors() {
        this.errors = {
            date: null,
            time: null,
            place: null,
            description: null
        }
    },
    validate(){
      this.cleansErrors()
      let valid = true
      if (this.date == '' || this.date == null){
        this.errors.date = "Fecha Requerida!"
        valid = false
      }

      if (this.time == '' || this.time == null){
        this.errors.time = "Hora Requerida!"
        valid = false
      }

      if (this.place == '' || this.place == null){
        this.errors.place = "Lugar Requerido!"
        valid = false
      }

      if (this.description == '' || this.description == null){
        this.errors.description = "Observación Requerida!"
        valid = false
      }

      return valid
    },
    async schedule() {
      if (this.validate()){
        try {
            this.loading = true
            const data = {
              victim: this.victimSelected,
              date: this.date,
              time: this.time,
              place: this.place,
              description: this.description
            }
            if (this.updateClaim){
              const resp = await this.$http.patch(`/claims/${this.claim.id}/medical/schedule`, data)
              this.claim.medical_date_hour = resp.data.medical_date_hour
              this.claim.medical_place = resp.data.medical_place
              this.claim.medical_description = resp.data.medical_description
            } else {
              const resp = await this.$http.patch(`/claims/victim/${data.victim}/medical/schedule`, data)
              this.claim.victims = resp.data.victims
            }
            this.$alertify.success('Visita médica agendada!') 
            this.victimSelected = null
            this.loading = false
        } catch (error) {
            this.loading = false
            this.$alertify.error('ERROR. No se ha podido agendar la visita médica!')
        } 
      }
    },
    async medicalAssistClaim(){
      this.loading = true
      const data = {
        assist: this.claim.medical_assist
      }
      try {
        const resp = await this.$http.patch(`/claims/${this.claim.id}/medical/schedule/assist`, data)
        if (data.assist){
          this.$alertify.success('Se registro que la víctima asistió!') 
          if (resp.move){
            this.$emit('refreshData', this.claim.id)
          }
        } else {
          this.$alertify.success('Se registro que la víctima no asistió!') 
        }
        this.loading = false
      } catch (error) {
          this.loading = false
          if (data.assist){
            this.$alertify.error('ERROR. No se ha podida marcar que la víctima asistió!')
            this.claim.medical_assist = false
          } else {
            this.$alertify.error('ERROR. No se ha podida marcar que la víctima no asistió!')
            this.claim.medical_assist = true
          }
      }
    },
    async medicalAssistVictim(victim){
      this.loading = true
      const data = {
        assist: victim.medical_assist
      }
      try {
        const resp = await this.$http.patch(`claims/victim/${victim.id}/medical/schedule/assist`, data)
        if (data.assist){
          this.$alertify.success('Se registro que la víctima asistió!') 
          if (resp.move){
            this.$emit('refreshData', this.claim.id)
          }
        } else {
          this.$alertify.success('Se registro que la víctima no asistió!') 
        }
        this.loading = false
       } catch (error) {
         this.loading = false
         if (data.assist){
            this.$alertify.error('ERROR. No se ha podida marcar que la víctima asistió!')
            victim.medical_assist = false
          } else {
            this.$alertify.error('ERROR. No se ha podida marcar que la víctima no asistió!')
            victim.medical_assist = true
          }
       }
    },
    viewInfo(object){
      this.$alertify.alert(
        'Información', 
        '<b>Lugar</b><br>'+object.medical_place+'<br><br><b>Observación</b><br>'+object.medical_description
      )
    }
  },
}
</script>